module.exports = __webpack_public_path__ + "static/media/br-ba.f07d330c.svg";